import { Vue, Component, Ref } from 'vue-property-decorator'

@Component
export default class CommonPetitionerListModalDetail extends Vue {
    @Ref() readonly commonPetitionerListModalDetail!: any
    private petitionerList: Array<object> = [
        {
            fullName: 'JIMÉNEZ RODRÍGUEZ JOSÉ LUIS',
            dateTime: '22/01/2021 10:44',
            casePetitioner: true
        },
        {
            fullName: 'SUÁREZ VÁZQUEZ MARÍA DOLORES',
            dateTime: '22/01/2021 10:44',
            casePetitioner: false
        }
    ]

    show() {
        this.commonPetitionerListModalDetail.show()
    }

    hide() { this.commonPetitionerListModalDetail.hide() }
}
